<template>
  <table class="productVariantGrid table-cell-responsive table-default text-center text-sm-left" :class="[settings.Styles.BorderStyle]">
    <thead class="hidden-xs" :class="[settings.Styles.TableHeaderSettings.BackGroundStyle, settings.Styles.TableHeaderSettings.TextStyle]">
      <tr>
        <td :class="[settings.Styles.BorderStyle]" v-if="settings.ColumnSettings.ShowImage">&nbsp;</td>
        <td :class="[settings.Styles.BorderStyle]"><b>{{settings.ColumnLabels.ItemNameLable}}</b></td>
        <td :class="[settings.Styles.BorderStyle]" v-if="settings.ColumnSettings.ShowUnitPerPack"><b>{{settings.ColumnLabels.UnitsPerPackLable}}</b></td>
        <td :class="[settings.Styles.BorderStyle]" v-if="settings.ColumnSettings.ShowPrice"><b>{{settings.ColumnLabels.PriceLable}}</b></td>
        <td :class="[settings.Styles.BorderStyle]" v-if="settings.ColumnSettings.ShowDefaultPrice"><b>{{settings.ColumnLabels.DefaultPriceLable}}</b></td>
        <td :class="[settings.Styles.BorderStyle]" v-if="settings.ColumnSettings.ShowDiscountOfCurrentAndDefaultPrice"><b>{{settings.ColumnLabels.DiscountOfCurrentAndDefaultPriceLable}}</b></td>
        <td :class="[settings.Styles.BorderStyle]" v-if="settings.ColumnSettings.ShowStock"><b>{{settings.ColumnLabels.StockLable}}</b></td>
        <td :class="[settings.Styles.BorderStyle]"><b>{{settings.ColumnLabels.QuantityLable}}</b></td>
        <td :class="[settings.Styles.BorderStyle]" v-if="settings.ColumnSettings.ShowTotal"><b>{{settings.ColumnLabels.TotalLable}}</b></td>
      </tr>
    </thead>
    <tbody v-if="order">
      <!--<tr :class="[settings.Styles.BorderStyle, settings.Styles.BackGroundStyle]">
        <td colspan="9" :class="[settings.Styles.BorderStyle]">
          <autocomplete-lookup-products-and-variants @item-selected="addToCart($event)"
                                                     :buttonStyle="settings.Styles.ButtonStyle"
                                                     :showSearchOptionPanel="settings.ProductSearchSettings.ShowSearchOptionPanel"
                                                     :defaultSearchOptionKey="settings.ProductSearchSettings.DefaultSearchOptionKey"
                                                     :productSearchPageUrl="settings.ProductSearchSettings.ProductSearchPageUrl"
                                                     :messageToDisplayWhenAProductCannotBePurchased="settings.ProductSearchSettings.MessageToDisplayWhenAProductCannotBePurchased"></autocomplete-lookup-products-and-variants>
        </td>
      </tr>-->
      <orderline v-for="(bol, i) in order.OrderLines" :key="bol.Id" :orderline="bol" :settings="settings" :rowIndex="i+1" :active="bol.Id === lastEditOrderlineId"></orderline>
      <tr :class="[settings.Styles.BorderStyle, settings.Styles.BackGroundStyle, 'bg-perc_30']">
        <td colspan="9" :class="[settings.Styles.BorderStyle]">
          <div class="row">
            <div class="col-xs-6 col-sm-8">
              <autocomplete-lookup-products-and-variants @item-selected="addToCart($event)"
                                                         :buttonStyle="settings.Styles.ButtonStyle"
                                                         :showSearchOptionPanel="settings.ProductSearchSettings.ShowSearchOptionPanel"
                                                         :defaultSearchOptionKey="settings.ProductSearchSettings.DefaultSearchOptionKey"
                                                         :productSearchPageUrl="settings.ProductSearchSettings.ProductSearchPageUrl"
                                                         :messageToDisplayWhenAProductCannotBePurchased="settings.ProductSearchSettings.MessageToDisplayWhenAProductCannotBePurchased"></autocomplete-lookup-products-and-variants>
            </div>
            <div class="col-xs-6 col-sm-4 text-right">
              <a :href="settings.OrderSettings.CartUrl" class="btn" :class="[settings.Styles.ButtonStyle]"><i class="fa fa-sign-in"></i>Go To Cart</a>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
    <tbody v-else>
      <tr :class="[settings.Styles.BorderStyle, settings.Styles.BackGroundStyle, 'bg-perc_30']">
        <td colspan="9" :class="[settings.Styles.BorderStyle]">
          <div class="row">
            <div class="col-xs-6 col-sm-8">
              <autocomplete-lookup-products-and-variants @item-selected="addToCart($event)"
                                                         :buttonStyle="settings.Styles.ButtonStyle"
                                                         :showSearchOptionPanel="settings.ProductSearchSettings.ShowSearchOptionPanel"
                                                         :defaultSearchOptionKey="settings.ProductSearchSettings.DefaultSearchOptionKey"
                                                         :productSearchPageUrl="settings.ProductSearchSettings.ProductSearchPageUrl"
                                                         :messageToDisplayWhenAProductCannotBePurchased="settings.ProductSearchSettings.MessageToDisplayWhenAProductCannotBePurchased"></autocomplete-lookup-products-and-variants>
            </div>
            <div class="col-xs-6 col-sm-4 text-right">
              <a :href="settings.OrderSettings.CartUrl" class="btn" :class="[settings.Styles.ButtonStyle]"><i class="fa fa-sign-in"></i>Go To Cart</a>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
  import AutocompleteLookupProductsAndVariants from "./AutocompleteLookupProductsAndVariants";
  import Orderline from "./Orderline";
  import { OrderService, BundleOrderLine } from "../../Models/Order/OrderService";

  export default {
    name: "SmartOrderGrid",
    components: {
      Orderline,
      AutocompleteLookupProductsAndVariants
    },
    props: {
      settings: {
        type: Object,
        default: {
          Styles: {
            BorderStyle: 'c3-borders',
            BackGroundStyle: 'c1-bg',
            TableHeaderSettings: {
              BackGroundStyle: 'c1-bg',
              TextStyle: ''
            }
          },
          ColumnSettings: {
            ShowImage: true,
            ShowUnitPerPack: true,
            ShowPrice: true,
            ShowTotal: true
          }
        }
      }
    },
    data() {
      return {
        searchKeyword: '',
        searchResult: [],
        lastEditOrderlineId: ''
      };
    },
    computed: {
      order: function () {
        //console.log('this.$store.state.order',this.$store.state.order);
        return this.$store.state.order;
      },
      orderService: function () {
        return new OrderService();
      }
    },
    mounted() {
      //console.log('this.settings', this.settings);
    },
    methods: {
      addToCart(item) {
        if (!item.CanBePurchased) return;

        const qty = item.MinimumPurchaseQuantity > 0 ? item.MinimumPurchaseQuantity : (item.PurchaseStepQuantity > 0 ? item.PurchaseStepQuantity : 1);
        const bol = new BundleOrderLine(item.ProductIdentifier, qty, false);

        this.orderService.addOrUpdateOrderLines([bol])
          .then(({ data }) => {
            $.refreshSiteAfterCartUpdateForBundle(data);
            this.lastEditOrderlineId = bol.Id;
          });
      }
    }
  };
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// EcomCore/Components/Products/SmartOrderGrid.vue